<template>
  <tr>
    <td>
      <b-input v-model="awayTeam" />
    </td>
    <td>
      <b-input v-model="homeTeam" />
    </td>
    <td>
      <b-input v-model="body" />
    </td>
    <td>
      <b-datetimepicker :append-to-body="true" v-model="dateTime"></b-datetimepicker>
    </td>

    <td>
      <div class="buttons is-centered">
        <b-button icon-left="close" type="has-text-danger" @click="$emit('removeBet', wager.id)" />
      </div>
    </td>
  </tr>
</template>

<script>
import {BDatetimepicker} from 'buefy/dist/esm/datetimepicker';

export default {
  components: {
    BDatetimepicker
  },
  props: {
    wager: Object
  },
  data() {
    return {
      awayTeam: '',
      homeTeam: '',
      body: '',
      dateTime: new Date()
    }
  },
  mounted() {
    let {wager} = this;

    // Strings
    ['awayTeam', 'homeTeam', 'body']
      .forEach(datum => {
        if (datum in this && datum in wager) {
          this[datum] = wager[datum];
        }
      });

    // Dates
    ['dateTime']
      .forEach(datum => {
        if (datum in this && datum in wager) {
          this[datum] = wager[datum] instanceof Date ? wager[datum] : new Date(wager[datum]);
        }
      });
  },
  watch: {
    awayTeam: function (newVal) {
      this.$emit('updateBet', {
        id: this.wager.id,
        edits: {
          awayTeam: newVal
        }
      })
    },
    homeTeam: function (newVal) {
      this.$emit('updateBet', {
        id: this.wager.id,
        edits: {
          homeTeam: newVal
        }
      })
    },
    body: function (newVal) {
      this.$emit('updateBet', {
        id: this.wager.id,
        edits: {
          body: newVal
        }
      })
    },
    dateTime: function (newVal) {
      this.$emit('updateBet', {
        id: this.wager.id,
        edits: {
          dateTime: newVal
        }
      })
    }
  }
}
</script>